import React, { useContext, useEffect, useState } from "react";
import { Collapse, Modal } from "react-bootstrap";
import InputForm from "../../../Components/InputForm/InputForm";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { TextField, Tooltip } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box, Modal as Modal2 } from "@mui/material";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import "./Accordian.css";
import "./Accordian6.css";
import { APICall } from "../../../Helpers/API/APICalls";
import notify from "../../../Helpers/ToastNotification";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import {
  getRMStatusOptions,
  InsertUpdateRiskMitigation,
  getResponsiblePersonsDropdown,
  getRiskMitigationHistory,
} from "../../../Helpers/API/APIEndPoints";
import Heading from "../../../Components/Heading/Heading";
import moment from "moment";
//For TL & BA
const Accordian6 = ({
  data: mainData,
  selectedEngagement: selectedEngagement,
}) => {
  const [isOpen, setIsOpen] = useState<any>(false);
  const { EmployeeId, RoleId } = getContext();
  const [isActive, setIsActive] = useState<boolean>(false);
  const [testData, setData] = useState(mainData);
  const [disableFields, setDisableFields] = useState(false);
  const [selectedEngagementValue] = useState(selectedEngagement);
  const [personsOptions, setPersonsOptions] = useState<any>([]);
  const [responsiblePersonsValue, setResponsiblePersonsValue] = useState<any>(
    []
  );

  const { showLoader, hideLoader } = useContext(LoaderContext);

  const [formErrors, setFormErrors] = useState({});

  const [open, setOpen] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [historyGridData, setHistoryGridData] = useState<any>([]);
  const [start, setStart] = useState(0);
  const RoleIdArray = RoleId.split(",");
  const [rmStatusOptions, setRMStatusOptions] = useState<any>([]);
  const [rmStatusValue, setRMStatusValue] = useState<any>();
  const [rmRemarkValue, setRMRemarkValue] = useState<any>([]);
  let formErrorObj = {};

  const handleOpen = async (id) => {
   // console.log("dat==>", testData);
    getHistoryData(testData?.id);
    setOpen(true);
  };
  // console.log('testdata===>',testData)

  const handleClose = () => setOpen(false);

  useEffect(() => {
    (async () => {
      await getHistoryData(testData?.id);
    })();
  }, [start, pageSize]);

  const getResponsiblePerson = async () => {
    let obj = {
      EngagementId: selectedEngagementValue,
    };

    const { data } = await APICall(getResponsiblePersonsDropdown, "POST", obj);

    if (data != null && data != undefined) {
      let customArray = data.map((ele: any) => {
        return {
          value: ele.employeeId,
          label: ele.responsiblePersons,
        };
      });
      setPersonsOptions(customArray);

      let responsiblePersonsArray = [];
      responsiblePersonsArray = testData?.responsiblePersons?.split(", ");

      if (responsiblePersonsArray?.length > 0) {
        let values = [];
        responsiblePersonsArray?.forEach((element) => {
          if (customArray.some((x) => x.value === Number(element))) {
            let tempEle = customArray.find((x) => x.value === Number(element));
            values.push({ label: tempEle.label, value: tempEle.value });
          }
        });

        setResponsiblePersonsValue(values);
      }
    }
  };

  const getHistoryData = async (id) => {
   // console.log("id=>", id);
    const { data } = await APICall(getRiskMitigationHistory, "POST", { id });
   // console.log("history data=>", data);
    if (data != null) {
      setHistoryGridData(data);
    }
  };

  useEffect(() => {
    // Gets Status Dropdown Options
    (async () => {
      showLoader();
      const { data } = await APICall(getRMStatusOptions, "POST", {});

      if (data !== null && data.length > 0) {
        setRMStatusOptions(data);
      } else {
        setRMStatusOptions([]);
      }
      hideLoader();
    })();
    getResponsiblePerson();

    setRMRemarkValue(testData?.remark);
  }, []);
  useEffect(() => {
    if (rmStatusOptions.length > 0) {
     // console.log("status ooption=>", rmStatusOptions);
      const obj = rmStatusOptions.find(
        (ele) => Number(ele.value) === Number(testData.statusId)
      );
     // console.log(obj);
      setRMStatusValue(obj);
    }
  }, [rmStatusOptions]);
  const optionsHis = {
    selectableRows: "none",
    count: false,
    rowsPerPage: false,
    serverSide: false,
    rowsPerPageOptions: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    pagination: false,

    setCellHeaderProps: () => ({ align: "center" }),
  };

  // const gridColumnsHis = [
  //     {
  //       name: "id",
  //       label: "Id",
  //       options: {
  //         display: false,
  //         filter: false,
  //         sort: false,
  //       },
  //     },
  //     {
  //       name: "riskTitle",
  //       label: "Risk Title",
  //       options: {
  //         filter: false,
  //         sort: false,
  //         sortDescFirst: true,
  //       },
  //     },
  //     {
  //       name: "responsiblePersons",
  //       label: "Responsible Person",
  //       options: {
  //         filter: false,
  //         sort: false,
  //         sortDescFirst: true,
  //       },
  //     },
  //     {
  //       name: "dueDate",
  //       label: "Due Date",
  //       options: {
  //         filter: false,
  //         sort: false,
  //         sortDescFirst: true,
  //         customBodyRender: (value) =>
  //           value ? moment(value).format("DD-MMM-YYYY") : "",
  //        },
  //     },
  //     {
  //       name: "status",
  //       label: "Status",
  //       options: {
  //         filter: false,
  //         sort: false,
  //         sortDescFirst: true,
  //       },
  //     },
  //     {
  //       name: "remark",
  //       label: "Remarks",
  //       options: {
  //         filter: false,
  //         sort: false,
  //         sortDescFirst: true,
  //       },
  //     },
  // ];

  const gridColumnsHis = [
    // {
    //   name: "id",
    //   label: "Id",
    //   options: {
    //     display: false,
    //     filter: false,
    //     sort: false,
    //   },
    // },
    // {
    //   name: "riskTitle",
    //   label: "Risk Title",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: true,
    //   },
    // },
    // {
    //   name: "responsiblePersons",
    //   label: "Responsible Person",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: true,
    //   },
    // },
    // {
    //   name: "dueDate",
    //   label: "Due Date",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: true,
    //     customBodyRender: (value) =>
    //       value ? moment(value).format("DD-MMM-YYYY") : "",
    //    },
    // },
    {
      name: "createdByStr",
      label: "User",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "createdDate",
      label: "DateTime",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
        customBodyRender: (value) => {
          return moment.utc(value).local().format("DD-MM-YYYY HH:mm:ss");
        },
      },
    },
    {
      name: "remark",
      label: "Remarks",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },

    // {
    //   name: "",
    //   label: "Action",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value, tableMeta) => {
    //       let id = tableMeta.tableData[tableMeta.rowIndex].Id;
    //       let data =  tableMeta.tableData[tableMeta.rowIndex]

    //       return (
    //         <>
    //           <a
    //             onClick={(e) => {
    //               e.preventDefault();

    //               navigate("RiskMitigationEdit", { state: id });
    //             }}
    //           >
    //             <i className="fa fa-pencil" aria-hidden="true"></i>
    //           </a>

    //           <a
    //             onClick={() => {
    //               setIsOpen(true)
    //             }}
    //             style={{marginLeft : '10px'}}
    //           >
    //             <i className="fa fa-history" aria-hidden="true"></i>
    //           </a>

    //         </>
    //       );
    //     },
    //   },
    // },
    // {
    //   name: "isActive",
    //   label: "Active",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value, tableMeta) => {
    //       if (value == "Yes") {
    //         return <i className="fas fa-check"></i>;
    //       } else {
    //         return <i className="fas fa-times"></i>;
    //       }
    //     },
    //   },
    // },
  ];
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    height: "50%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    borderRadius: 3,
    boxShadow: 24,
    p: 4,
    //overflow : 'scroll'
  };

  const submitValidation = async () => {
    await setFormErrors({});

    if (!rmStatusValue || rmStatusValue.length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["rmStatus_isEmpty"]: "Status cannot be empty",
      }));
      formErrorObj["rmStatus_isEmpty"] = "Status cannot be empty";
    }
  };

  const submitFunc = async (action: any) => {
    if (action === "submit") {
      await submitValidation();

      let isEmpty = Object.values(formErrorObj).every(
        (f) => f === "" || f === null || f === undefined
      );

      if (isEmpty) {
        let submitObj: any = {};
        submitObj = {
          EngagementId: selectedEngagement,
          Id: testData?.id,
          StatusId: rmStatusValue?.value,
          Remark: rmRemarkValue || "",
          ResponsiblePersons: testData?.responsiblePersons || "",
          RiskTitle: testData?.riskTitle || "",
          RiskDescription: testData?.riskDescription || "",
          MitigationActions: testData?.mitigationActions || "",
          DueDate: testData?.dueDate,
          CreatedBy: EmployeeId,
        };

        const { data } = await APICall(
          InsertUpdateRiskMitigation,
          "POST",
          submitObj
        );

        if (data && data.id != (null || undefined)) {
          notify(0, "Risk Mitigation Updated Successfully.");
          if (rmStatusValue?.code === "Completed") {
            setDisableFields(true);
          }
        } else {
          notify(1, "Something went wrong!!!");
        }
      }
    }
    if (action === "reset") {
      resetFunc();
    }
  };

  const resetFunc = () => {
    setFormErrors({});
    setRMRemarkValue("");
    setRMStatusValue([]);
  };

  return (
    <>
      {testData && (
        <>
          <div className="card">
            <div
              style={{ backgroundColor: "#c1d0d7 important" }}
              className="card-header"
              id="headingOne"
              onClick={() => setIsActive(!isActive)}
            >
              <div data-toggle="collapse" data-target="#collapseOne">
                <div className="col-lg-12 row p-0 m-0">
                  <div className="col-lg-12 p-0">
                    {/* check status then render */}
                    {/* {testData.status.id !== 1 && (
                                            <i
                                                className="fa fa-hourglass-end mr-2 yellow-col"
                                                aria-hidden="true"
                                            ></i>
                                        )} */}
                    {rmStatusValue &&
                      rmStatusValue.value == 2 && ( //completed
                        <i
                          className="fa fa-check-circle mr-2"
                          aria-hidden="true"
                        ></i>
                      )}
                    {rmStatusValue &&
                      rmStatusValue.value == 4 && ( //in progress
                        <i
                          className="fa fa-hourglass-end mr-2 yellow-col"
                          aria-hidden="true"
                        ></i>
                      )}
                    <span> </span> {testData.riskTitle}
                    <span className="float-right">
                      <span>
                        {moment(testData.dueDate).format("DD-MM-YYYY")}
                      </span>
                      <span>
                        {" "}
                        <i className="fa fa-chevron-down"></i>{" "}
                      </span>
                    </span>
                  </div>
                </div>

                {/* <div className="col-lg-12 row p-0 m-0">
                                    <div className="col-lg-12 p-0 mt-2 sub-text">
                                    
                                    </div>
                                </div> */}
                <div className="col-lg-12 row p-0 m-0">
                  <div className="col-lg-12 p-0 mt-2 sub-text">
                    <span>
                      {moment(testData.dueDate).isBefore(moment(), "day") && (
                        <i
                          className="fa fa-fire mr-2 red-col"
                          aria-hidden="true"
                        ></i>
                      )}
                    </span>
                    <span>
                      {testData.engagementName && (
                        <>{testData.engagementName}</>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <Collapse in={isActive}>
              <div>
                <>
                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordionExample"
                  >
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-6 col-md-4 col-sm-6">
                          <div className="form-group">
                            <label>
                              Risk Description <sup>*</sup>
                            </label>
                            <InputForm
                              placeholder={""}
                              isDisabled={true}
                              textArea={true}
                              rows={4}
                              value={testData.riskDescription}
                              onChange={(e) => {
                                //handleTextEvent(e, "Issues");
                              }}
                            />
                            <p style={{ color: "red" }}>
                              {formErrors["issue_isEmpty"]}
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-4 col-sm-6">
                          <div className="form-group">
                            <label>
                              Mitigation Actions <sup>*</sup>
                            </label>
                            <InputForm
                              placeholder={""}
                              isDisabled={true}
                              textArea={true}
                              rows={4}
                              value={testData.mitigationActions}
                              onChange={(e) => {
                                //handleTextEvent(e, "Issues");
                              }}
                            />
                            <p style={{ color: "red" }}>
                              {formErrors["issue_isEmpty"]}
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-4 col-sm-6">
                          <div className="form-group">
                            <label>Responsible Person's</label>
                            <sup>*</sup>
                            <InputForm
                              placeholder={""}
                              isDisabled={true}
                              textArea={false}
                              // rows={4}
                              value={responsiblePersonsValue
                                .map((person) => person.label)
                                .join(", ")}
                              onChange={(e) => {
                                //handleTextEvent(e, "Issues");
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6">
                          <div className="form-group">
                            <label className="d-block">
                              Due Date <sup>*</sup>
                            </label>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                label="End date"
                                disabled={true}
                                value={testData.dueDate}
                                onChange={
                                  (e) => {}
                                  //handleTextEvent(e, "EndDate");
                                }
                                inputFormat="dd/MM/yyyy"
                                renderInput={(params) => (
                                  <TextField size="small" {...params} />
                                )}
                              />
                              <p style={{ color: "red" }}>
                                {formErrors["endDate_isEmpty"]}
                              </p>
                            </LocalizationProvider>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6">
                          <div className="form-group">
                            <label>
                              Status <sup>*</sup>
                            </label>
                            <SelectForm
                              options={rmStatusOptions}
                              placeholder="Select"
                              isDisabled={disableFields}
                              value={rmStatusValue}
                              onChange={(event) => setRMStatusValue(event)}
                              isMulti={false}
                              noIndicator={false}
                              noSeparator={false}
                            />
                            <p style={{ color: "red" }}>
                              {formErrors["rmStatus_isEmpty"]}
                            </p>
                          </div>
                        </div>

                        {/* <div className="row"> */}
                        {/* {responsiblePersonsValue &&
                                responsiblePersonsValue?.length > 0 && (
                                    <React.Fragment key={''}>
                                        <div className="col-lg-3 col-sm-3 col-xs-4">
                                        <div className="dropdown mb-1">
                                            <label className="col-form-label">
                                            Responsible Persons
                                            </label>
                                            <sup>*</sup>
                                            <SelectForm
                                            isClearable
                                            isSearchable
                                            isDisabled={true}
                                            value={responsiblePersonsValue}
                                            options={personsOptions}
                                            placeholder={`No Responsible Person Found`}
                                            onChange={(e) => {
                                                alert("Change");
                                            }}
                                            isMulti={true}
                                            noIndicator={false}
                                            noSeparator={false}
                                            />
                                            <div className="dropdown-content">
                                            {responsiblePersonsValue &&
                                                responsiblePersonsValue?.length > 0 &&
                                                responsiblePersonsValue?.map(
                                                (eachApp) => <p>{eachApp.label}</p>
                                                )}
                                            </div>
                                        </div>
                                        </div>
                                    </React.Fragment>
                                    )}                     */}
                        {/* </div> */}

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>
                              Remark
                              {/* <sup>*</sup> */}
                            </label>
                            <InputForm
                              placeholder={""}
                              isDisabled={disableFields}
                              textArea={true}
                              rows={4}
                              value={rmRemarkValue}
                              onChange={(e) => {
                                setRMRemarkValue(e.target.value);
                              }}
                            />
                            {/* <p style={{ color: "red" }}>
                                                                            {formErrors["issue_isEmpty"]}
                                                                        </p> */}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="fill-hours">
                              <a
                                className="mr-2"
                                onClick={() => {
                                  handleOpen(testData.id);
                                  setIsOpen(true);
                                }}
                                style={{
                                  cursor: "pointer",
                                }}
                              >
                                {" "}
                                <i className="fa fa-clock mr-1"></i> History{" "}
                              </a>
                            </div>
                            <div className="fillUpdate d-flex gap-2">
                              <button
                                disabled={disableFields}
                                className="btn btn-reset"
                                onClick={() => submitFunc("reset")}
                              >
                                Reset
                              </button>
                              <button
                                disabled={disableFields}
                                className="btn btn-submit"
                                onClick={() => submitFunc("submit")}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </Collapse>
            {/* <React.Fragment>
              <Modal
                open={isOpen}
                onClose={() => setIsOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <>
                    <div className="display-flex">
                      <Heading title={"Risk Mitigation History"}></Heading>
                    </div>
                    <div
                      style={{
                        maxHeight: "calc(100% - 70px)",
                        overflowY: "auto",
                        paddingBottom: "10px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      }}
                    ></div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        marginTop: "10px",
                      }}
                    ></div>
                  </>
                </Box>
              </Modal>
            </React.Fragment> */}
          </div>

          <>
            <Modal
              show={isOpen}
              onHide={() => setIsOpen(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              backdrop="static"
              centered
              size="lg"
              scrollable={true}
            >
              <Modal.Header closeButton>
                <Modal.Title>Risk Mitigation History</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <DynamicGrid
                  columns={gridColumnsHis}
                  data={historyGridData}
                  options={optionsHis}
                />
              </Modal.Body>
              <Modal.Footer>
                <button
                  onClick={() => setIsOpen(false)}
                  className="btn btn-reset"
                >
                  Close
                </button>
              </Modal.Footer>
            </Modal>
          </>

          {/* <>
                        <Modal2
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                            hideBackdrop={true}
                        >
                            <Box sx={style}>
               <>
               <div className="display-flex">
                <Heading title={"Risk Mitigation History"}></Heading>
               </div>
                <div
                  style={{
                    maxHeight: 'calc(100% - 70px)',  
                    overflowY: 'auto',  
                  }}
                >
                  <DynamicGrid
                    columns={gridColumnsHis}
                    data={historyGridData}
                    options={optionsHis}
                  />
               </div>

               <button
                  onClick={() => setOpen(false)}
                  className="btn btn-primary mr-2"
                  style={{
                    position : 'absolute',
                    bottom: '15px',
                    right: '15px',  
                    marginTop: '18px',
                  }}
                >
                  Cancel
                </button>

               </>
            </Box>
                        </Modal2>
                    </> */}
        </>
      )}
    </>
  );
};

export default Accordian6;
